export function fmtDateTime(iso: string) {
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(iso));
}

export function fmtDate(iso: string) {
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(iso));
}

export function tipoVeiculoLabel(v: string) {
  const map: Record<string, string> = {
    auto_leve: "Auto/Leve",
    moto: "Moto",
    caminhao: "Caminhão",
    onibus: "Ônibus",
  };
  return map[v] ?? v;
}

export function metodoPgtoLabel(m: string | null | undefined) {
  if (!m) return "—";
  const map: Record<string, string> = {
    pix: "PIX",
    boleto: "Boleto",
    credit_card: "Cartão",
  };
  return map[m] ?? m;
}

export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

export function formatCpf(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9)
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}

export function formatCnpj(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 14);
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 12)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

export function formatCep(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

/** Formata CPF (11 dígitos) ou CNPJ (14 dígitos) conforme o comprimento digitado */
export function formatDocumento(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.length <= 11) return formatCpf(digits);
  return formatCnpj(digits);
}

// Unformat functions - remove all non-digit characters
export function unformatPhone(value: string): string {
  return value.replace(/\D/g, "");
}

export function unformatCpf(value: string): string {
  return value.replace(/\D/g, "");
}

export function unformatCnpj(value: string): string {
  return value.replace(/\D/g, "");
}

export function unformatCep(value: string): string {
  return value.replace(/\D/g, "");
}

export function unformatDocumento(value: string): string {
  return value.replace(/\D/g, "");
}

/**
 * Formata placa brasileira (normal ou Mercosul)
 * Normal: ABC1234 → ABC-1234
 * Mercosul: ABC1D23 → ABC-1D23
 */
export function formatPlaca(value: string): string {
  const clean = value.replace(/\W/g, "").toUpperCase().slice(0, 7);

  // Detecta se é Mercosul (tem letra na 5ª posição)
  const isMercosul = /^[A-Z]{3}\d[A-Z]\d{2}$/.test(clean);

  if (clean.length <= 3) return clean;
  if (isMercosul || (clean.length === 7 && /[A-Z]/.test(clean[4]))) {
    // Mercosul: ABC-1D23
    return `${clean.slice(0, 3)}${clean.slice(3)}`;
  }
  // Normal: ABC-1234
  if (clean.length <= 4) return clean;
  return `${clean.slice(0, 3)}-${clean.slice(3)}`;
}

/** Remove formatação da placa */
export function unformatPlaca(value: string): string {
  return value.replace(/\W/g, "").toUpperCase();
}

/** Formata placa normal (ABC1234 → ABC-1234) */
export function formatPlacaNormal(value: string): string {
  const clean = value.replace(/\W/g, "").toUpperCase().slice(0, 7);
  if (clean.length <= 3) return clean;
  if (clean.length <= 4) return clean;
  return `${clean.slice(0, 3)}-${clean.slice(3)}`;
}

/** Formata placa Mercosul (ABC1D23 → ABC-1D23) */
export function formatPlacaMercosul(value: string): string {
  const clean = value.replace(/\W/g, "").toUpperCase().slice(0, 7);
  if (clean.length <= 3) return clean;
  if (clean.length <= 4) return clean;
  return `${clean.slice(0, 3)}-${clean.slice(3)}`;
}
